import { render, staticRenderFns } from "./PC.vue?vue&type=template&id=2607c2ec&scoped=true&"
import script from "./PC.vue?vue&type=script&lang=js&"
export * from "./PC.vue?vue&type=script&lang=js&"
import style0 from "./PC.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./PC.vue?vue&type=style&index=1&id=2607c2ec&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2607c2ec",
  null
  
)

export default component.exports